import React, { FC, useState, useEffect } from "react"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
//mui
import { makeStyles, Typography, Box } from "@material-ui/core"
//components
import LoginButton from "../../reuseableComponents/login"
//auth
import { isLoggedIn } from "../../../utils/auth"
import { isBrowser } from "../../../../../gatsby-auth/gatsby-firebase-simple-auth/src/utils/auth"

interface porps {
  blogTitle: string
  description: string
}

const BlogContent: FC<porps> = ({ blogTitle, description }) => {
  const [status, setStatus] = useState<boolean>()

  //it will rerender component after it catches state from local storage
  useEffect(() => {
    setStatus(isLoggedIn())
  }, [status, isLoggedIn()])

  const useStyle = makeStyles(theme => ({
    title: {
      fontWeight: 600,
      color: "#313131",
    },

    description: {
      maxHeight: !status ? "150px" : "",

      overflow: "hidden",
      position: "relative",
      bottom: 0,
      left: 0,
      width: "100%",
      zIndex: 1,
    },
    overlay: {
      width: "100%",
      position: "absolute",
      height: "100%",
      backgroundImage: "linear-gradient(to bottom, transparent ,white)",
    },
    loginBtn: {
      position: "absolute",
      top: "70px",
      left: "50%",
      transform: "translateX(-50%)",
      margin: "0 auto",
    },
  }))

  const classes = useStyle()

  return (
    <div>
      <Box pb={3}>
        <Typography className={classes.title} variant="h4">
          {blogTitle}
        </Typography>
      </Box>
      <Box>
        {" "}
        <div className={classes.description}>
          {status ? null : <div className={classes.overlay}></div>}
          <Typography color="textSecondary">{description}</Typography>
          {status ? null : (
            <div className={classes.loginBtn}>
              <LoginButton title="Read Blog" />
            </div>
          )}
        </div>
      </Box>
    </div>
  )
}

export default BlogContent
